export const NON_PREFIX_CERTIFICATE_ID_LENGTH = "12345678-1234-1234-1234-123456789abc".length;
export const PREFIX_CERTIFICATE_ID_SUFFIX_LENGTH = 7;

export const getCertificateIdLength = (prefix: string): number => {
    if (!prefix) {
        return NON_PREFIX_CERTIFICATE_ID_LENGTH;
    }
    return prefix.length + 1 + PREFIX_CERTIFICATE_ID_SUFFIX_LENGTH;
};
